import { useMutation } from '@tanstack/react-query';

import type { HttpError } from 'src/shared/utils/HttpError';
import { UseCustomMutationOptions } from 'src/shared/utils/queryHelpers';
import { getQueryClient } from 'src/shared/utils/queryClient';

import { generateQueryKeys } from '../utils';
import { sendSmsFetcher, signAgreementFetcher } from './userService';
import type { TSendSmsRequestPayload, TSignAgreementRequestPayload } from './typing';

const userQueryKeys = generateQueryKeys('user');

export const useMutationSendSms = (options?: UseCustomMutationOptions<void, HttpError, TSendSmsRequestPayload>) => {
  const queryClient = getQueryClient();

  return useMutation({
    mutationFn: async (payload: TSendSmsRequestPayload) => sendSmsFetcher({ data: payload }),
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: [userQueryKeys.all] });
      await options?.onSuccess?.(data, variables, context);
    },
  });
};

export const useMutationSignAgreement = (
  options?: UseCustomMutationOptions<void, HttpError, TSignAgreementRequestPayload>,
) => {
  const queryClient = getQueryClient();

  return useMutation({
    mutationFn: async (payload: TSignAgreementRequestPayload) => signAgreementFetcher({ data: payload }),
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: [userQueryKeys.all] });
      await options?.onSuccess?.(data, variables, context);
    },
  });
};
